<ng-container *ngIf="!showDisplayNumberSelector && !!contact">
  <form #contactForm="ngForm">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="
      margin: -24px -24px 16px -24px;
      padding: 8px 24px;
      max-width: initial;">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" style="margin-right: 32px;">
        <gt-contact-avatar [contact]="contact" [size]="'80px'"></gt-contact-avatar>
        <h3>{{title}}</h3>
      </div>
      <div fxLayout="row">
        <button mat-icon-button id="editButton" (click)="enableEditMode()"
                matTooltip="{{'contact_detail.edit' | translate}}"
                *ngIf="!editMode && canEdit() && !contact.isServiceNumber()">
          <mat-icon>
            edit
          </mat-icon>
        </button>

        <button mat-icon-button (click)="deleteContact()" id="deleteButton"
                matTooltip="{{'contact_detail.delete' | translate}}"
                *ngIf="(contact.isContact() || contact.isInternalContact()) && contact.isStored()">
          <mat-icon>
            delete
          </mat-icon>
        </button>

        <button mat-icon-button id="close-dialog-button" (click)="goBack()" matTooltip="{{'global.close' | translate}}">
          <mat-icon>
            close
          </mat-icon>
        </button>
      </div>
    </div>

    <div fxLayout="column">
      <mat-form-field *ngIf="!editMode" cdkFocusRegionstart>
        <mat-icon matPrefix class="prefix-icon">
          person
        </mat-icon>
        <input id="contactDetailNameInput" name="contactDetailNameInput" matInput
               placeholder="{{'global.name' | translate}}" value="{{getContactName()}}"
               [readonly]="true" required>
      </mat-form-field>
      <ng-container *ngIf="editMode">
        <mat-form-field cdkFocusRegionstart>
          <mat-icon matPrefix class="prefix-icon">
            person
          </mat-icon>
          <input id="contactDetailFirstNameInput" name="contactDetailFirstNameInput" matInput
                 placeholder="{{'contact_detail.first_name' | translate}}" [(ngModel)]="contact.firstName"
                 required>
        </mat-form-field>
        <mat-form-field cdkFocusRegionstart>
          <mat-icon matPrefix class="prefix-icon">
            person
          </mat-icon>
          <input id="contactDetailLastNameInput" name="contactDetailLastNameInput" matInput
                 placeholder="{{'contact_detail.last_name' | translate}}" [(ngModel)]="contact.lastName"
                 required>
        </mat-form-field>
      </ng-container>

      <mat-form-field>
        <mat-icon matPrefix class="prefix-icon">
          phone
        </mat-icon>
        <input matInput id="numberInput" name="numberInput" placeholder="{{'contact_detail.number' | translate}}"
               [ngModel]="(!editMode || !contact.isContact()) ? (contact.phoneNumber | phoneNumberFormatter) :
         (contact.isStored()? (contact.phoneNumber | phoneNumberFormatter) : (contact.phoneNumber))"
               (ngModelChange)="numberChanged($event)" [readonly]="!editMode || !contact.isContact()" required>
      </mat-form-field>

      <mat-form-field *ngIf="!contact.isServiceNumber()">
        <mat-icon matPrefix class="prefix-icon">
          phone
        </mat-icon>
        <input id="shortNumberInput" name="shortNumberInput" matInput placeholder="{{'contact_detail.short_number' | translate}}"
               [(ngModel)]="contact.shortNumber" [readonly]="!editMode">
      </mat-form-field>

      <mat-form-field *ngIf="!contact.isServiceNumber()">
        <mat-icon matPrefix class="prefix-icon">
          location_on
        </mat-icon>
        <input id="addressInput" name="addressInput" matInput placeholder="{{'contact_detail.address' | translate}}" [(ngModel)]="address"
               [readonly]="!editMode">
        <a matSuffix mat-icon-button *ngIf="address" href="https://www.google.com/maps/place/{{address}}" target="maps"
           matTooltip="{{ 'contact_detail.address_in_map' | translate }}">
          <mat-icon>map</mat-icon>
        </a>
      </mat-form-field>

      <mat-form-field *ngIf="!contact.isServiceNumber()">
        <mat-icon matPrefix class="prefix-icon">
          email
        </mat-icon>
        <input id="emailInput" name="emailInput" matInput placeholder="{{'contact_detail.email' | translate}}" [(ngModel)]="contact.email"
               [readonly]="!editMode">
        <a matSuffix mat-icon-button *ngIf="contact.email" href="mailto:{{ contact.email }}"
           matTooltip="{{'contact_detail.send_email' | translate}}">
          <mat-icon>alternate_email</mat-icon>
        </a>
      </mat-form-field>

      <mat-form-field *ngIf="!contact.isServiceNumber() && hasDepartments">
        <mat-icon matPrefix class="prefix-icon">
          domain
        </mat-icon>
        <input *ngIf="!showDepartmentSelector" id="departmentInput" name="departmentInput" matInput
               placeholder="{{'contact_detail.department' | translate}}" [(ngModel)]="contact.department"
               [readonly]="!editMode">
        <mat-select *ngIf="showDepartmentSelector" [ngModel]="contact.department"
                    (ngModelChange)="setDepartment($event)"
                    [disabled]="!editMode">
          <mat-option *ngFor="let department of departments" [value]="department.name">
            {{ department.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *gtHasOneOf="[products.WEBRTC_PRODUCT]">
        <button *ngIf="registered" [disabled]="ongoingCall" mat-raised-button fxFill color="primary"
                (click)="callContactVOIP(contact.phoneNumber)">
          {{'contact_detail.call_voip' | translate}}
        </button>

        <button mat-raised-button color="primary" (click)="transferCallToContactVOIP(contact.phoneNumber)"
                [disabled]="!contact.isEndUser()" id="transferButton" *ngIf="amICallee">
          {{'contact_detail.transfer' | translate}}
        </button>
      </ng-container>

      <div fxLayout="row" fxLayoutGap="8px" *ngIf="!editMode">
        <button fxFlex="50" mat-button color="primary" (click)="showClick2Call()" gtDisableWhenNotloggedin>
          {{'contact_detail.call_display_number' | translate}}
        </button>
        <button fxFlex="50" mat-button color="primary" (click)="navigateToSendMsg()">
          {{'contacts.send_sms' | translate}}
        </button>
      </div>
      <div fxLayout="row" fxLayoutGap="8px" *ngIf="editMode">
        <button *ngIf="showCancelButton; else showCallButton" fxFlex="50" mat-button color="primary" (click)="cancel()">
          {{'global.cancel' | translate}}
        </button>
        <ng-template #showCallButton>
          <button fxFlex="25" mat-button color="primary" (click)="showClick2Call()" gtDisableWhenNotloggedin>
            {{'contact_detail.call' | translate}}
          </button>
          <button fxFlex="25" mat-button color="primary" (click)="navigateToSendMsg()">
            {{'contacts.send_sms' | translate}}
          </button>
        </ng-template>

        <button fxFlex="50" mat-button color="primary"
                (click)="save()" [disabled]="contactForm.invalid">
          {{'global.save' | translate}}
        </button>
      </div>
    </div>
  </form>
</ng-container>
